module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./src/app/news/news/news.component.html
// module id = 835
// module chunks = 1